(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cap-arrow-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cap-arrow-finder')) {
    customElements.define('cap-arrow-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.capSubmit) return;
        this.capSubmit = (event) => {
          const select = this.querySelector('select');
          if (!select || !select.value) return;
          event.preventDefault();
          window.location.assign(select.value);
        };
        this.addEventListener('submit', this.capSubmit);
        if (Number(this.dataset.productCount) > 50) this.loadAllArrows();
      }
      async loadAllArrows() {
        const select = this.querySelector('select');
        const status = this.querySelector('.cap-arrow-finder__status');
        const button = this.querySelector('button');
        status.textContent = status.dataset.loading;
        status.hidden = false;
        button.disabled = true;
        this.capAbort = new AbortController();
        const signal = this.capAbort.signal;
        try {
          const options = new Map();
          let pages = 1;
          for (let page = 1; page <= pages; page++) {
            const url = new URL(this.dataset.collectionUrl, window.location.origin);
            url.searchParams.set('section_id', this.dataset.sectionId);
            url.searchParams.set('page', String(page));
            const response = await fetch(url, { signal });
            if (!response.ok) throw new Error('Arrow list unavailable');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const template = doc.querySelector('template[data-cap-arrow-options]');
            if (!template) throw new Error('Arrow list missing');
            pages = Math.max(1, Number(template.dataset.pages) || 1);
            template.content.querySelectorAll('option').forEach(option => {
              options.set(option.value, { value: option.value, text: option.textContent.trim() });
            });
          }
          if (options.size < Number(this.dataset.productCount)) throw new Error('Arrow list incomplete');
          const chosen = select.value;
          const sorted = Array.from(options.values()).sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }));
          select.replaceChildren(select.options[0], ...sorted.map(item => new Option(item.text, item.value)));
          if (chosen && options.has(chosen)) select.value = chosen;
          status.hidden = true;
        } catch (error) {
          if (signal.aborted) return;
          status.textContent = status.dataset.error;
        } finally {
          if (!signal.aborted) button.disabled = false;
        }
      }
      disconnectedCallback() {
        this.capAbort?.abort();
        this.removeEventListener('submit', this.capSubmit);
        this.capSubmit = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
